import DocsHeaderLogo from '../../../../assets/img/docs-header-logo.png'

import {
  Container, Content, HeaderTitle, Image
} from "./_docsHeader"

export const DocsHeader = () => {
  return (
    <Container>
      <Content>
        <Image src={DocsHeaderLogo} alt="Documents header" />
        <HeaderTitle>
          Envio de documentação
        </HeaderTitle>
      </Content>
    </Container>
  )
}
